import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import iView from 'iview';
import locale from 'iview/dist/locale/en-US';
import VueAgile from 'vue-agile';
import ApnicUI from 'apnic-ui';
import VueLazyload from 'vue-lazyload';
import VueTour from 'vue-tour';
import { library } from '@fortawesome/fontawesome-svg-core';
import VTooltip from 'v-tooltip';
import XEUtils from 'xe-utils';
import { VXETable, Table, Header, Column, Filter, Icon } from 'vxe-table';
import enUS from 'vxe-table/lib/locale/lang/en-US';
// set vxe-table language
VXETable.setup({
  i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(enUS, key), args)
});

import filters from './filters/globalFilters';

import {
  faCheckCircle,
  faChevronDown,
  faCaretUp,
  faCaretDown,
  faChevronUp,
  faExternalLinkAlt,
  faInfoCircle,
  faCalendarAlt,
  faChevronLeft,
  faChevronRight,
  faArrowAltCircleRight,
  faHistory,
  faTimes,
  faBars,
  faExclamationTriangle,
  faExclamationCircle,
  faEllipsisV,
  faSearch,
  faSort,
  faCheck,
  faSortAmountDown,
  faFilter,
  faTimesCircle,
  faAngleDoubleLeft,
  faTachometerAlt,
  faBell,
  faListUl,
  faNewspaper,
  faInfo,
  faServer,
  faBalanceScale,
  faMinusCircle,
  faCopy,
  faQuestionCircle
} from '@fortawesome/free-solid-svg-icons';

import { faCheckCircle as faCheckCircleO } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// import 'bootstrap/dist/css/bootstrap.css'; // add this back if you need the original bootstrap
import 'iview/dist/styles/iview.css';
import 'bootstrap/dist/js/bootstrap';
// import 'apnic-bootstrap4/dist/css/apnic-app-bootstrap4.min.css';
// import 'apnic-bootstrap4/dist/js/apnic-bootstrap4';
import '@webops/web-framework-theme/dist/css/theme-app.min.css';
import '@webops/web-framework-theme/dist/js/theme.min.js';
import './styles/fonts.css';
import 'apnic-ui/packages/scss/main.scss';
import './styles/typography.scss';
import 'vue-tour/dist/vue-tour.css';
import './styles/tooltip.scss';

library.add(
  faCheckCircle,
  faCheckCircleO,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faCaretDown,
  faCaretUp,
  faExternalLinkAlt,
  faInfoCircle,
  faCalendarAlt,
  faArrowAltCircleRight,
  faHistory,
  faTimes,
  faBars,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faEllipsisV,
  faSearch,
  faSort,
  faCheck,
  faSortAmountDown,
  faFilter,
  faTimesCircle,
  faAngleDoubleLeft,
  faTachometerAlt,
  faBell,
  faListUl,
  faNewspaper,
  faInfo,
  faServer,
  faBalanceScale,
  faMinusCircle,
  faCopy,
  faQuestionCircle
);

Vue.component('fa', FontAwesomeIcon);
Vue.use(VueTour);

Vue.use(VueAgile);
Vue.use(VTooltip);

Vue.use(iView, { locale: locale });

Vue.use(ApnicUI);
Vue.use(VueLazyload);

Vue.use(filters);

// import vxe-table on demand
Vue.use(Column);
Vue.use(Header);
Vue.use(Filter);
Vue.use(Icon);
Vue.use(Table);

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
